const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

const toUtcDayInTimeZone = (date: Date, timeZone: string) => {
  const [month, day, year] = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
    .format(date)
    .split('/')
    .map(Number)
  return Date.UTC(year, month - 1, day)
}

// 0 = today, 1 = tomorrow, -1 = yesterday – as seen in the given time zone, independent of the runtime's time zone
export const getCalendarDaysFromToday = (date: Date, timeZone: string) =>
  (toUtcDayInTimeZone(date, timeZone) - toUtcDayInTimeZone(new Date(), timeZone)) / ONE_DAY_IN_MS
